import { Link } from "react-router-dom"

export default function ViewMonitorButton({ id }: { id: string | number }) {
    return (
        <Link className="btn btn-sm btn-virtual" to={`/my/monitors/${id}`}>
            <i className="bi bi-file-earmark-text text-primary me-1" />
            View
        </Link>
    )
}